import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { replace, map } from 'lodash';
import { Paths } from "../routes/Routes";
import { User } from "../../models/User";
import { renderPeriod, displayAcknowledgeDate } from "../../helpers/renderHelper";
import IncidentCard from "../common/IncidentCard";
import NoContent from "../common/NoContent";
import { Organization } from "../../models/Organization";
import { buildIncidents } from "../../helpers/incidentHelper";
import { useAppDispatch } from "../../redux/hooks";
import { clearBackNavigation } from "../../redux/navigationSlice";
import ScoreTile from "../common/ScoreTile";
import { AppMessages } from "../../strings";
import RankProgress from "../common/RankProgress";
import StreakSection from "../common/StreakSection";
import IdleProjectionChart from "../common/IdleProjectionChart";
import ConfirmAcknowledgmentModal from "./ConfirmAcknowledgmentModal";
import { useMutation } from '@apollo/client';
import { ACKNOWLEDGE_SCORECARD } from '../../graphQL/queries';
import { updateAcknowledgmentDate } from "../../redux/appStateSlice";

const DriverSummary = ({currentUser, currentOrganization}:{currentUser?: User, currentOrganization?:Organization}) => {

	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const clearAcknowledgment = false;
		
	// Check if organization has idle rule
	const hasIdleRule = currentOrganization?.goals?.some(goal => goal.goalTypeName === 'Idle');
	const showIdleChart = hasIdleRule;
	
	// Get idle goal target value from organization, fallback to 10
	const goal = currentOrganization?.goals?.find(g => g.goalTypeName === 'Idle')?.targetValue ?? 10; 

	const [showConfirmAcknowledgmentModal, setShowConfirmAcknowledgmentModal] = useState(false)

	const [confirmAcknowledgment, confirmAcknowledgmentResponses] = useMutation(ACKNOWLEDGE_SCORECARD);

	function navigateToIncidentDetail(e, incident) {
		const path = replace(Paths.DRIVER_INCIDENT_DETAIL, ':name', incident.name)
		navigate(path);
	}

	var	scorecard = currentUser?.scorecard
	const showAcknowledgeButton = clearAcknowledgment || (scorecard ? scorecard.currentScore && scorecard.acknowledgment !== null && scorecard.acknowledgment?.acknowledgedDate === null : false)
	const showAcknowledgedDate = scorecard ? scorecard.currentScore && scorecard.acknowledgment !== null && scorecard.acknowledgment?.acknowledgedDate !== null : false;

	// const incidents = flatMap(currentUser?.scorecard, sc => sc.incidents)
	const incidents = currentUser?.scorecard?.incidents
	const filteredIncidents = buildIncidents(incidents)
	const acknowledgedDate = scorecard?.acknowledgment ? scorecard?.acknowledgment?.acknowledgedDate : null

	useEffect(()=>{
		dispatch(clearBackNavigation())
	},[dispatch])

	useEffect(()=>{
		if (confirmAcknowledgmentResponses?.data) {
			dispatch(updateAcknowledgmentDate(confirmAcknowledgmentResponses?.data?.ack))
		}
	},[confirmAcknowledgmentResponses?.data, dispatch])


	function confirmAcknowledgmentClicked() {

		setShowConfirmAcknowledgmentModal(false);
		confirmAcknowledgment({
			variables: {
				acknowledgment: {
					acknowledgmentID: currentUser?.scorecard?.acknowledgment?.acknowledgmentID
				},
				clear: clearAcknowledgment
			}
		});
	}

	function promptToConfirmAcknowledgment(e) {
		e.preventDefault()
		setShowConfirmAcknowledgmentModal(true);
	}

	return (
		<Fragment>
			<div className="container app-page-text" style={{marginTop:0}}>
				{ renderPeriod(currentOrganization, { filled: true }) }
				{/* Scores */}
				<div className="row">
					<div className="col-12">
						<div className="card" style={{marginBottom: "0.35rem"}}>
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row text-center g-0 p-0" >
									<ScoreTile score={scorecard} />
									<RankProgress score={scorecard} />
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Acknowledge */}
				{ showAcknowledgeButton && 
					<div className="row">
						<div className="col-12">
						<div className="card" style={{marginBottom: "0.35rem"}}>
							<div className="card-body align-items-center" style={{padding:"0.35rem"}}>
							<div className="text-center">
								<form>
								<button className="w-100 btn btn-lg btn-primary text-dark" onClick={ e => promptToConfirmAcknowledgment(e) } >Acknowledge</button>
								</form>
							</div>
							</div>
						</div>
						</div>
					</div>
				}
				{ showAcknowledgedDate && 
					<div className="row">
						<div className="col-12 align-items-center">
						  <div className="card" style={{height:40}}>
						    <div className="card-body align-items-center" style={{padding: '0.35rem', display:'flex' }}>
							  <div className="fs-10 fst-italic mt-sm-0 app-page-text" style={{ alignSelf:'center', margin:'auto'}} >{ acknowledgedDate && <i className="fa-solid fa-square-check icn-orange" style={{marginRight:10}}/> }{acknowledgedDate ? displayAcknowledgeDate(acknowledgedDate) ?? "Not Acknowledged" : "Not Required"}</div>
						    </div>
						  </div>
						</div>
					</div>
				}
				<div className="row">
					<div className="col-12">
						<div className="card" >
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row g-0 p-0">
									{ (filteredIncidents.length > 0) ? (
										<Fragment>
											{
												map(filteredIncidents,(incident,index) => {
													return <IncidentCard key={`driver-553-${index}`} currentIncident={incident} onClick={e => navigateToIncidentDetail(e, incident)} />
												})
											}
										</Fragment>
									) : (
										<NoContent message={scorecard?.currentScore ? AppMessages.noIncidents : AppMessages.noDriverScore} showIcon={scorecard?.currentScore ? true : false} compact={true} />
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<StreakSection userStreaks={currentUser?.userStreaks} />
				
				{/* Area Chart Section - Only show when idle parameter is present */}
				{showIdleChart && (
					<IdleProjectionChart
						idleInfo={currentUser?.idleInfo}
						idleProjection={currentUser?.idleProjection}
						goal={goal}
						userID={currentUser?.userID}
					/>
				)}
			</div>
			{ showConfirmAcknowledgmentModal && <ConfirmAcknowledgmentModal shouldShow={showConfirmAcknowledgmentModal} onConfirmAcknowledgment={()=>confirmAcknowledgmentClicked()} onClose={()=>setShowConfirmAcknowledgmentModal(false) } />}

		</Fragment>
	)
}

export default DriverSummary;
